import React from "react";
import "./secondSection.css";
import secondSectionImg from "../../assets/secondSectionImg.png";
import mobilevewsection2 from "../../assets/mobilevewsection2.png";
const SecondSection = () => {
  return (
    <div className="secondSection-main-wrapper">
      <div className="secondSection-inner-wrapper">
        <div className="ourBackstory-text-container">
          <div className="first-Paragraph">
            <h1>OUR BACKSTORY</h1>
            <p>
              8,888 Potatoes on the Ethereum blockchain, living in Potato Town
              building their own potato community! These guys have one goal and
              one goal only: open the biggest party club the metaverse has ever
              seen. Come join them on their mission as they discover the ways of
              life on the blockchain, help them make all the necessary
              preparations in order to open the club, and establish their very
              own potato community. None of this will happen overnight, but with
              your help the result will be out of this world! (No pun intended)
            </p>
          </div>
          <div className="second-Paragraph">
            <h3>A MESSAGE FROM THE TEAM</h3>
            <p>
              Party Potato Club is a long-term project that our team fully
              believes in and will be working on it for many years. We are
              committed to building a strong community for years to come that
              will share this journey with us. We want the project to be a
              profitable one for us and for our holders, and we will do
              everything in our power to make that happen.<br/><br/> When you mint a Party
              Potato Club NFT, that means that you buy into our vision for the
              project and put your faith in us to bring that to fruition. Our
              team understands the responsibility we have towards the community
              and people who invest their money with us. We will do everything
              that is in our power to make this project a successful one, a
              project that our team and the community we build can be proud of.<br/><br/>
              Thank you for considering us. If you choose to join us, you will
              be a part of a community that will have real genuine utility, and
              a promise to build into the future.<br/><br/><br/> Best wishes,<br/><br/> Party Potato Club
              Team
            </p>
          </div>
        </div>
        <div className="Image-studio">
          <img className="pc" src={secondSectionImg} alt="secondSectionImg" />
          <img className="mob" src={mobilevewsection2} alt="mobilevewsection2" />
        </div>
      </div>
    </div>
  );
};

export default SecondSection;
